export default function useGetCombinedAttributes({ networkError, helperText, error, }) {
    const getCombinedHelperText = () => {
        if (networkError)
            return 'Failed request, try updating later';
        if (helperText)
            return helperText;
        return '';
    };
    const getCombinedError = () => {
        return !!(error || networkError);
    };
    return {
        helperText: getCombinedHelperText(),
        error: !!getCombinedError(),
    };
}
